module.exports = __webpack_public_path__ + "30707da5731ac591e4e8f419ea818d3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/sso/components/header/images/logo.png
// module id = 433
// module chunks = 0